import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';

export const EnterpriseTitle: FC = () => <FormattedMessage id="empty-state.enterprise-title" />;
